module.exports = __webpack_public_path__ + "static/media/giada-logo.d14f0c6f.svg";